import axios from 'axios';
import $ from 'jquery';

import { store } from '../store';
import { TCF_URL } from '../api/URLs';
import { donationAPIs } from '../api';
import { buildDonationPayload, checkoutActions, donationActions } from '../store/actions';
import { ACH, APPLE, GOOGLE, STRIPE, VENMO, RECAPTCHA_TOKEN, PAYPAL } from '../constants';
import { compiledName, convertFirstLetterToUpperCase, decodeJwt, totalCheckoutDonation } from './CommonFunctions';
import { UPDATE_DONATION_PROCESSING_STATE } from '../store/actionTypes';
import { validateCheckout } from '../validations';

export const loadUnifiedCheckoutScript = (src, integrity) => {
	return new Promise((resolve, reject) => {
		if (document.querySelector(`script[src="${src}"]`)) {
			resolve();
			return;
		}

		const script = document.createElement('script');
		script.src = src;
		script.integrity = integrity;
		script.crossOrigin = 'anonymous';
		script.async = true;

		script.onload = resolve;
		script.onerror = reject;

		document.body.appendChild(script);
	});
};

export const confirmStripeCardPayment = async (stripeIntentResponse, state, stripeReference) => {
	let stripeResponse = {};
	const isGoogleApplePay = state.selectedPaymentMethod == GOOGLE || state.selectedPaymentMethod == APPLE;

	let paymentIntentSecret = state.recurringDonation ? stripeIntentResponse.payment_intent : stripeIntentResponse.client_secret;

	if (stripeIntentResponse?.payment_status?.status === 'succeeded') {
		stripeResponse = {
			paymentIntent: stripeIntentResponse.payment_status,
		};
	} else stripeResponse = await stripeReference.current.handleToken(paymentIntentSecret, state.recurringDonation);

	if (stripeResponse) stripeResponse.is_google_apple_pay = isGoogleApplePay;

	return stripeResponse;
};

export const getStripeIntent = async (payload, isFundraiserCheckout) => {
	const isCampaignPage = isFundraiserCheckout ? 0 : 1;

	const response = await donationAPIs.getStripIntent(payload, isCampaignPage);
	if (response.data && response.data.success) return response.data.success;
};

export const StripeCheckout = async (payload, stripeIntentResponse, state, dispatch) => {
	const stripeResponse = await confirmStripeCardPayment(stripeIntentResponse, state);
	if (stripeResponse) {
		const userDetailsWithStripeResponse = { ...payload, ...stripeResponse };
		state.isFundraiserCheckout
			? dispatch(donationActions.checkoutStripe(userDetailsWithStripeResponse))
			: dispatch(donationActions.checkoutStripe(userDetailsWithStripeResponse, 1));
		return userDetailsWithStripeResponse;
	} else return false;
};

export const handleStripe = async (payload, state) => {
	const globalState = store.getState();

	const stripeReference = globalState.checkoutPaymentRefs.stripeReference;
	const googleApplePayReference = globalState.checkoutPaymentRefs.googleApplePayReference;

	const stripeRef = state.selectedPaymentMethod == STRIPE ? stripeReference : googleApplePayReference;
	try {
		const stripeIntent = await getStripeIntent(payload, state.isFundraiserCheckout);
		const stripeResponse = await confirmStripeCardPayment(stripeIntent, state, stripeRef);
		state.isRecurring
			? (payload = {
					...payload,
					donation_id: stripeIntent.donation_id,
					intent_client_secret: stripeIntent.payment_intent,
					start_date: stripeIntent.start_date,
					end_date: stripeIntent.end_date,
					status: stripeIntent.status,
					invoice_id: stripeIntent.invoice_id,
					stripe_sub_id: stripeIntent.stripe_sub_id,
					...stripeResponse,
			  })
			: (payload = {
					...payload,
					donation_id: stripeIntent.donation_id,
					intent_client_secret: stripeIntent.client_secret,
					...stripeResponse,
			  });
		state.isFundraiserCheckout ? store.dispatch(donationActions.checkoutStripe(payload)) : store.dispatch(donationActions.checkoutStripe(payload, 1));
	} catch (error) {
		throw error;
	}
};

export const handleBankCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	const bankTransferPayload = {
		...checkoutPayload,
		bank_id: checkoutDetails.selectedBank.bank_id,
		attachment: checkoutDetails.bankSlip.attachment,
	};
	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutBankTransfer(bankTransferPayload))
		: store.dispatch(donationActions.checkoutBankTransfer(bankTransferPayload, 1));
};

export const handleChequeCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	const chequePayload = {
		...checkoutPayload,
		cheque_no: checkoutDetails.chequeNumber,
	};
	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutChequeDeposit(chequePayload))
		: store.dispatch(donationActions.checkoutChequeDeposit(chequePayload, 1));
};

export const handleHBLCheckout = async (checkoutPayload) => {
	let hblPayload = {};
	const checkoutDetails = store.getState().donationCheckout;

	try {
		const response = await axios.get(TCF_URL.GET_USER_IP);
		const userIp = response.data.IPv4;
		hblPayload = { ...checkoutPayload, customer_ip_address: userIp };
	} catch {
		hblPayload = { ...checkoutPayload, customer_ip_address: '127.0.0.1' };
	}
	hblPayload = {
		...hblPayload,
		bill_to_address_city: checkoutDetails.userContactDetails.city,
		bill_to_address_postal_code: checkoutDetails.userContactDetails.zipCode,
		bill_to_address_state: checkoutDetails.userContactDetails.countryState,
		bill_to_phone: checkoutDetails.userContactDetails.contactNumber,
		bill_to_address_country: checkoutDetails.selectedCountry.code,
	};
	await store.dispatch(donationActions.getHBLConfig(hblPayload));
	// $("#payment_form").submit();
	$('#payment_form').trigger('submit');
	//     $("#payment_form").requestSubmit();
};

export const handleUnifiedCheckout = async (checkoutPayload) => {
	const globalState = store.getState();
	const checkoutDetails = globalState.donationCheckout;
	try {
        const captureContextResponse = await store.dispatch(donationActions.getCaptureContext(checkoutPayload));
        if (!captureContextResponse?.token) {
            throw new Error('Failed to get capture context');
        }

        const tokenPayload = decodeJwt(captureContextResponse.token);
        const { clientLibrary, clientLibraryIntegrity } = tokenPayload.ctx[0].data;
        await loadUnifiedCheckoutScript(clientLibrary, clientLibraryIntegrity);

        const accept = await window.Accept(captureContextResponse.token);
        const up = await accept.unifiedPayments(true);
        const trigger = up.createTrigger('PANENTRY');
		
		store.dispatch({
			type: UPDATE_DONATION_PROCESSING_STATE,
			processing: false,
		});
		const transientToken = await trigger.show();
        const completeResponse = await up.complete(transientToken);
		store.dispatch(donationActions.updateLoaderState(true));
		const decodedCompleteResponse = decodeJwt(completeResponse);
		const verifyPayload = {
			donation_id: captureContextResponse.donation_id,
			transaction_id: decodedCompleteResponse.id,
			request_id: transientToken,
			status: decodedCompleteResponse.status,
			...(checkoutDetails.isRecurring && {
                token_information: decodedCompleteResponse.details?.tokenInformation
            })
		};
		await new Promise(resolve => setTimeout(resolve, 5000));
		const verifyResponse = await store.dispatch(donationActions.verifyUCPayment(verifyPayload));
		
    } catch (error) {
        if (error.name === "AcceptError") {
            console.error('Cybersource SDK Error Detected:');
            console.error('Reason:', error.reason);   // e.g., "SHOW_LOAD_ERROR" or "USER_TERMINATED"
            console.error('Message:', error.message);
            console.error('Details:', error.details); // Array of specific field errors

        } else {
            console.error('General Error:', error.message);
        }
    }
};

export const handlePaypalCheckout = async (checkoutPayload) => {
	const checkoutDetails = store.getState().donationCheckout;

	if (checkoutDetails.isRecurring) {
		checkoutDetails.isFundraiserCheckout
			? await store.dispatch(donationActions.checkoutRecurringPaypal(checkoutPayload))
			: await store.dispatch(donationActions.checkoutRecurringPaypal(checkoutPayload, 1));
	} else {
		checkoutDetails.isFundraiserCheckout
			? await store.dispatch(donationActions.checkoutOnetimePaypal(checkoutPayload))
			: await store.dispatch(donationActions.checkoutOnetimePaypal(checkoutPayload, 1));
	}
};

export const handleACHCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const ACHReference = globalState.checkoutPaymentRefs.ACHReference;

	const paymentIntent = await ACHReference.current.confirmUsBankAccountPayment();

	let achPayload = {
		...checkoutPayload,
		...paymentIntent,
		is_google_apple_pay: false,
		is_ach: 1,
		donation_id: checkoutDetails.achIntentDetails.donation_id,
	};

	if (checkoutDetails.isRecurring) {
		achPayload = {
			...achPayload,
			start_date: checkoutDetails.achIntentDetails.start_date,
			end_date: checkoutDetails.achIntentDetails.end_date,
			invoice_id: checkoutDetails.achIntentDetails.invoice_id,
			stripe_sub_id: checkoutDetails.achIntentDetails.stripe_sub_id,
		};
	}

	checkoutDetails.isFundraiserCheckout
		? store.dispatch(donationActions.checkoutStripe(achPayload))
		: store.dispatch(donationActions.checkoutStripe(achPayload, 1));
};

export const getACHPaymentIntent = async (donationDetails, achOption) => {
	const { selectedPaymentMethod, paymentMethodDetails, ...blockingErrors } = validateCheckout();

	if (!Object.keys(blockingErrors).length)
		try {
			const payload = {
				channel: 'p2p',
				currency_id: donationDetails.selectedCountry.currency.id,
				country_id: donationDetails.selectedCountry.id,
				bill_to_forename: compiledName(donationDetails.userContactDetails.firstName),
				bill_to_surname: compiledName(donationDetails.userContactDetails.lastName),
				bill_to_email: donationDetails.userContactDetails.email,
				bill_to_phone: donationDetails.userContactDetails.contactNumber,
				city: donationDetails.userContactDetails.city,
				zip_code: donationDetails.userContactDetails.zipCode,
				bill_to_address_line1: donationDetails.userContactDetails.address,
				donation_amount: totalCheckoutDonation(donationDetails),
				payment_method_name: ACH,
				verification_method: achOption,
				is_recurring: donationDetails.isRecurring ? 1 : 0,
			};
			const paymentIntent = await donationAPIs.getACHIntent(payload);
			return paymentIntent.data.success;
		} catch (error) {
			throw error;
		}
	else {
		store.dispatch(checkoutActions.resetCheckoutPaymentMethod());
		throw new Error('Required fields are missing');
	}
};

export const getVenmoPaymentIntent = async () => {
	const globalState = store.getState();

	if (Object.keys(globalState.validationErrors).length) {
		store.dispatch(checkoutActions.resetCheckoutPaymentMethod());
		throw new Error('Required fields are missing');
	}

	try {
		const recaptchaToken = await window.grecaptcha.execute(`${RECAPTCHA_TOKEN}`, { action: 'submit' });

		// UPDATED: full payload via buildDonationPayload; fundraiser_page_id/campaign_id is
		// already handled inside it based on isFundraiserCheckout, so no need to set it here.
		const payload = {
			...buildDonationPayload(globalState, recaptchaToken, null),
			payment_method_name: VENMO,
		};

		const isFundraiserCheckout = globalState.donationCheckout.isFundraiserCheckout;
		const campaignPage = isFundraiserCheckout ? 0 : 1;
		const response = await donationAPIs.venmoCheckout(payload, campaignPage);
		return response.data.success;
	} catch (error) {
		throw error;
	}
};

export const getACHPaymentIntentOriginalNote = null; // (no-op, ignore — placeholder removed below)

export const handleGoogleAppleCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const googleApplePaymentId = globalState.googleApplePaymentId;

	const googleApplePayload = {
		...checkoutPayload,
		is_google_apple_pay: true,
		google_apple_device_name: convertFirstLetterToUpperCase(checkoutDetails.selectedPaymentMethod),
	};
	if (checkoutDetails.isRecurring) googleApplePayload.payment_method = googleApplePaymentId;

	await handleStripe(googleApplePayload, checkoutDetails);
};

export const handleStripeCheckout = async (checkoutPayload) => {
	const globalState = store.getState();

	const checkoutDetails = globalState.donationCheckout;
	const stripeReference = globalState.checkoutPaymentRefs.stripeReference;

	let stripePayload = {
		...checkoutPayload,
		is_google_apple_pay: false,
		google_apple_device_name: null,
	};

	try {
		const response = await stripeReference.current.getPaymentMethod();

		if (response.paymentMethod) stripePayload = { ...stripePayload, payment_method: response.paymentMethod.id };
	} catch (error) {
		throw error;
	}

	await handleStripe(stripePayload, checkoutDetails);
};